import React from 'react'
import ReactDOM from 'react-dom/client'
import './static/css/index.css'
import './static/css/App.css'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import { applyMiddleware, combineReducers, createStore, compose } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import {
    globalNavigationReducer,
    phoneNumberVerificationReducer,
    userProfileReducer,
} from './config/store/reducers/reducers'
import { PROStudentCurrentProfileStateReducer } from './config/store/reducers/PROReducers'

const reducer = combineReducers({
    userProfileReducer,
    globalNavigationReducer,
    PROStudentCurrentProfileStateReducer,
    phone_number: phoneNumberVerificationReducer,
})

const middleware = [thunk]
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(...middleware))
)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <Provider store={store}>
        <React.StrictMode>
            <App />
            <ToastContainer />
        </React.StrictMode>
    </Provider>
)
